import { getApiBaseUrl } from "../config/runtimeConfig";
import { invalidateLookup } from "../lookups/lookupsApi";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface Worker {
  id: number;
  name: string;
  code?: string | null;
  role?: string | null;
  isActive: boolean;
  hourlyCost?: number | null;
  // Conta de login associada (permite ao trabalhador lançar as próprias horas).
  identityUserId?: string | null;
  // Encarregado de Obra: valida e lança horas da sua equipa.
  isSupervisor?: boolean;
  // Encarregado responsável por este trabalhador (quando não é ele próprio encarregado).
  supervisorId?: number | null;
  supervisorName?: string | null;
  created: string;
  lastModified: string;
}

export interface WorkerPayload {
  name: string;
  code?: string | null;
  role?: string | null;
  isActive: boolean;
  hourlyCost?: number | null;
  identityUserId?: string | null;
  isSupervisor?: boolean;
  supervisorId?: number | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getWorkers(): Promise<Worker[]> {
  return request<Worker[]>("/api/workers");
}

export function getWorkerById(workerId: number): Promise<Worker> {
  return request<Worker>(`/api/workers/${workerId}`);
}

export function createWorker(payload: WorkerPayload): Promise<Worker> {
  return request<Worker>("/api/workers", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((result) => {
    invalidateLookup("workers");
    return result;
  });
}

export function updateWorker(
  workerId: number,
  payload: WorkerPayload,
): Promise<Worker> {
  return request<Worker>(`/api/workers/${workerId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((result) => {
    invalidateLookup("workers");
    return result;
  });
}
